const SCOPE = 'app/checkout/';
export const ActionTypes = {
    SUBMIT_CONTACT_INFO: `${SCOPE}SUBMIT_CONTACT_INFO`,
    SUCCESSFULLY_PAYMENT: `${SCOPE}SUCCESSFULLY_PAYMENT`,
    CHANGE_USER_ID: `${SCOPE}CHANGE_USER_ID`,
    CHANGE_POSITION: `${SCOPE}CHANGE_POSITION`,
    CHANGE_CONTACT_INFO_IS_LOADING: `${SCOPE}CHANGE_CONTACT_INFO_IS_LOADING`,
    CHANGE_CONTACT_INFO_IS_ERROR: `${SCOPE}CHANGE_CONTACT_INFO_IS_ERROR`,
    CHANGE_CONTACT_INFO_ERROR_MESSAGE: `${SCOPE}CHANGE_CONTACT_INFO_ERROR_MESSAGE`,
    CHANGE_CONTACT_INFO: `${SCOPE}CHANGE_CONTACT_INFO`,
    CHANGE_CONTACT_INFO_FIRST_NAME: `${SCOPE}CHANGE_CONTACT_INFO_FIRST_NAME`,
    CHANGE_CONTACT_INFO_LAST_NAME: `${SCOPE}CHANGE_CONTACT_INFO_LAST_NAME`,
    CHANGE_CONTACT_INFO_EMAIL: `${SCOPE}CHANGE_CONTACT_INFO_EMAIL`,
    CHANGE_CONTACT_INFO_PHONE: `${SCOPE}CHANGE_CONTACT_INFO_PHONE`,
    CHANGE_CONTACT_INFO_SECONDARY_PHONE: `${SCOPE}CHANGE_CONTACT_INFO_SECONDARY_PHONE`,
    CHANGE_CONTACT_INFO_SEND_SMS: `${SCOPE}CHANGE_CONTACT_INFO_SEND_SMS`,
    CHANGE_CONTACT_INFO_TERMS_CONFIRMED: `${SCOPE}CHANGE_CONTACT_INFO_TERMS_CONFIRMED`,
    CHANGE_ORDER: `${SCOPE}CHANGE_ORDER`,
    CHANGE_ORDER_DETAIL: `${SCOPE}CHANGE_ORDER_DETAIL`,
    CHANGE_ORDER_IS_LOADING: `${SCOPE}CHANGE_ORDER_IS_LOADING`,
    CHANGE_ORDER_IS_ERROR: `${SCOPE}CHANGE_ORDER_IS_ERROR`,
    CHANGE_ORDER_ERROR_MESSAGE: `${SCOPE}CHANGE_ORDER_ERROR_MESSAGE`,
};

export const submitContactInfo = () => ({
    type: ActionTypes.SUBMIT_CONTACT_INFO,
});
export const successfullyPayment = (order) => ({
    type: ActionTypes.SUCCESSFULLY_PAYMENT,
    order,
});
export const changeUserId = (userId) => ({
    type: ActionTypes.CHANGE_USER_ID,
    userId,
});
export const changePosition = (position) => ({
    type: ActionTypes.CHANGE_POSITION,
    position,
});
export const changeContactInfo = ({ email, firstName, lastName, phone, secondaryPhone }) => ({
    type: ActionTypes.CHANGE_CONTACT_INFO,
    email,
    firstName,
    lastName,
    phone,
    secondaryPhone,
});
export const changeContactInfoIsLoading = (isLoading) => ({
    type: ActionTypes.CHANGE_CONTACT_INFO_IS_LOADING,
    isLoading,
});
export const changeContactInfoIsError = (isError) => ({
    type: ActionTypes.CHANGE_CONTACT_INFO_IS_ERROR,
    isError,
});
export const changeContactInfoErrorMessage = (errorMessage) => ({
    type: ActionTypes.CHANGE_CONTACT_INFO_ERROR_MESSAGE,
    errorMessage,
});
export const changeContactInfoFirstName = (firstName) => ({
    type: ActionTypes.CHANGE_CONTACT_INFO_FIRST_NAME,
    firstName,
});
export const changeContactInfoLastName = (lastName) => ({
    type: ActionTypes.CHANGE_CONTACT_INFO_LAST_NAME,
    lastName,
});
export const changeContactInfoEmail = (email) => ({
    type: ActionTypes.CHANGE_CONTACT_INFO_EMAIL,
    email,
});
export const changeContactInfoPhone = (phone) => ({
    type: ActionTypes.CHANGE_CONTACT_INFO_PHONE,
    phone,
});
export const changeContactInfoSecondaryPhone = (secondaryPhone) => ({
    type: ActionTypes.CHANGE_CONTACT_INFO_SECONDARY_PHONE,
    secondaryPhone,
});
export const changeContactInfoSendSms = (sendSms) => ({
    type: ActionTypes.CHANGE_CONTACT_INFO_SEND_SMS,
    sendSms,
});
export const changeContactInfoTermsConfirmed = (termsConfirmed) => ({
    type: ActionTypes.CHANGE_CONTACT_INFO_TERMS_CONFIRMED,
    termsConfirmed,
});

export const changeOrder = (order) => ({ type: ActionTypes.CHANGE_ORDER, order });
export const changeOrderDetail = (order) => ({
    type: ActionTypes.CHANGE_ORDER_DETAIL,
    order,
});
export const changeOrderIsLoading = (isLoading) => ({
    type: ActionTypes.CHANGE_ORDER_IS_LOADING,
    isLoading,
});
export const changeOrderIsError = (isError) => ({
    type: ActionTypes.CHANGE_ORDER_IS_ERROR,
    isError,
});
export const changeOrderErrorMessage = (errorMessage) => ({
    type: ActionTypes.CHANGE_ORDER_ERROR_MESSAGE,
    errorMessage,
});
